import { changeImageAlignment, toggleBlockMark } from '@atlaskit/editor-common/commands';
import { Selection } from '@atlaskit/editor-prosemirror/state';
/**
 * Iterates over the commands one after the other,
 * passes the tr through and dispatches the cumulated transaction
 */
function cascadeCommands(cmds) {
  return function (state, dispatch) {
    var baseTr = state.tr;
    var shouldDispatch = false;
    var onDispatchAction = function onDispatchAction(tr) {
      var selectionJSON = tr.selection.toJSON();
      baseTr.setSelection(Selection.fromJSON(baseTr.doc, selectionJSON));
      tr.steps.forEach(function (st) {
        baseTr.step(st);
      });
      shouldDispatch = true;
    };
    cmds.forEach(function (cmd) {
      return cmd(state, onDispatchAction);
    });
    if (dispatch && shouldDispatch) {
      dispatch(baseTr);
      return true;
    }
    return false;
  };
}
export var isAlignable = function isAlignable(align) {
  return function (state, dispatch) {
    var _state$schema = state.schema,
      _state$schema$nodes = _state$schema.nodes,
      paragraph = _state$schema$nodes.paragraph,
      heading = _state$schema$nodes.heading,
      alignment = _state$schema.marks.alignment;
    return toggleBlockMark(alignment, function () {
      return !align ? undefined : align === 'start' ? false : {
        align: align
      };
    }, [paragraph, heading])(state, dispatch);
  };
};
export var changeAlignment = function changeAlignment(align) {
  return function (state, dispatch) {
    var _state$schema2 = state.schema,
      _state$schema2$nodes = _state$schema2.nodes,
      paragraph = _state$schema2$nodes.paragraph,
      heading = _state$schema2$nodes.heading,
      alignment = _state$schema2.marks.alignment;
    return cascadeCommands([changeImageAlignment(align), toggleBlockMark(alignment, function () {
      return !align ? undefined : align === 'start' ? false : {
        align: align
      };
    }, [paragraph, heading])])(state, dispatch);
  };
};